import styled from 'styled-components';
import { useNavigate } from 'react-router';
import { useLocation } from 'react-router';

const StyledAPIDashboardToolBar = styled.div`
  width: 100%;
  margin-bottom: 25px;
  button:not(:first-child) {
    margin-left: 30px;
  }
`;

const StyledButton = styled.button<{ active?: boolean }>`
  height: 36px;
  font-size: 14px;
  cursor: pointer;
  background-color: inherit;
  color: rgb(185, 191, 199);
  border: none;
  padding: 8.25px 0;
  :hover {
    color: rgba(100, 111, 125, 255);
  }
  ${props => props.active && 'border-bottom: 2px solid blue; color: black;'}
`;

export const DashboardToolbar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <StyledAPIDashboardToolBar>
      <StyledButton
        onClick={() => navigate('/connector/list')}
        active={location.pathname.includes('list')}
      >
        Overview
      </StyledButton>
      <StyledButton
        onClick={() => navigate('/connector/add')}
        active={location.pathname.includes('add')}
      >
        Add
      </StyledButton>
    </StyledAPIDashboardToolBar>
  );
};
